module.exports = __webpack_public_path__ + "static/img/qiyeweixin14.c5cc48c.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qiyeweixin14.jpeg
// module id = H1yE
// module chunks = 0